import { useCallback } from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useDispatch } from 'react-redux';

import useFormData from '@gef-ui/form-core/hooks/state/useFormData';
import Form from '@gef-ui/form-material/Form';
import { getMessage } from '@gef-ui/localization/messages';

import Dialog from 'app/components/MaterialDialog';
import Version from 'components/atoms/Version';
import PAGES from 'constants/pages';
import dialog from 'features/common/dialog';
import { resetErrorsByPage } from 'features/common/submitFormDialog/slice';
import formDescriptorFn, { PRODUCED_PRODUCTION_NEW_MODAL_FORM_NAME } from 'features/views/productionNew/form';

import ProducedProductionNewModalBody from './ProducedProductionNewModalBody';

const ProducedProductionNewModal = NiceModal.create(({ document }) => {
	const dispatch = useDispatch();
	const modal = useModal();
	const mainFilterFormData = useFormData();

	const onExit = useCallback(() => {
		dispatch(dialog.actions.close(PRODUCED_PRODUCTION_NEW_MODAL_FORM_NAME));
		dispatch(resetErrorsByPage({ page: PRODUCED_PRODUCTION_NEW_MODAL_FORM_NAME }));
	}, [dispatch]);

	return (
		<Dialog
			modal={modal}
			title={getMessage('producedProductionNew:title')}
			onExit={onExit}
			content={
				<Form name={PRODUCED_PRODUCTION_NEW_MODAL_FORM_NAME} formDescriptorFn={formDescriptorFn}>
					<ProducedProductionNewModalBody document={document} mainFilterFormData={mainFilterFormData} />
				</Form>
			}
			maxWidth="lg"
			version={
				<Version
					screenId={PAGES.producedProduction.newModal.id}
					screenName={PAGES.producedProduction.newModal.name}
				/>
			}
		/>
	);
});

export default ProducedProductionNewModal;
